import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { FacilityBackend } from "../backend/api/facility.backend";
import { FacilityService } from "../services/facility.service";
import { first } from "lodash-es";
import { notifyFailure } from "../common/notify";
import { TranslocoService } from "@jsverse/transloco";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import { Facility } from "../backend/models/facility";
import { BootstrapService } from "../modules/bootstrap/bootstrap.service";
import { sntLog } from "src/app/common/logger";

const logger = sntLog("ProvideFacilityGuard");

@Injectable()
export class ProvideFacilityGuard {
  constructor(
    private transloco: TranslocoService,
    private facilityBackend: FacilityBackend,
    private facilityService: FacilityService,
    private bootstrapService: BootstrapService
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    try {
      const facility = route.params["facility"];

      logger.info(`provide ${facility}`);

      const facilities = await this.facilityBackend.list().toPromise();

      const facilityForCompany: Facility = first(facilities.list)!;

      this.facilityService.setCurrent(facilityForCompany);
      this.bootstrapService.setCurrentFacilityCode(facility);

      return true;
    } catch (ex) {
      notifyFailure(
        this.transloco.translate(marker("Sistema")),
        this.transloco.translate(marker("ProvideFacility")),
        ex
      );

      return false;
    }
  }
}
